/* reducer is used in client area */
import {  USER_LOGOUT, RESET_SELLERS_LIST, FETCH_ALL_SELLERS_LIST }  from "actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [] };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_ALL_SELLERS_LIST:
            console.log(FETCH_ALL_SELLERS_LIST, action.payload);
            return {
                data: action.payload.data,
            }
        case RESET_SELLERS_LIST:
            console.log(RESET_SELLERS_LIST, action.payload);
            return {
                data:  [] ,
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
